import { Directive, HostListener, Self, Input, OnDestroy, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subject } from 'rxjs';

@Directive({
  exportAs: 'cpInput',
  selector: '[cpInput]',
  host: {
    class: 'form-field__input',
  },
})
export class CpInput implements OnDestroy, OnInit {
  readonly stateChanges: Subject<void> = new Subject<void>();
  // todo:  placeholder doesnt seem to do anything need further research to remove
  @Input() placeholder: string;
  focus = false;

  constructor(@Self() private ngControl: NgControl) {}

  ngOnInit() {}
  get control() {
    return this.ngControl;
  }

  @HostListener('focus')
  onFocus() {
    this.focus = true;
    this.stateChanges.next();
  }
  @HostListener('focusout')
  onFocusout() {
    this.focus = false;
    this.stateChanges.next();
  }

  ngOnDestroy() {
    this.stateChanges.complete();
  }
}
